import { defineChain } from '../../utils/chain/defineChain.js';
import { chainConfig } from '../../zksync/chainConfig.js';
export const abstractTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig,
    id: 11_124,
    name: 'Abstract Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://api.testnet.abs.xyz'] },
    },
    blockExplorers: {
        default: {
            name: 'Abstract Block Explorer',
            url: 'https://sepolia.abscan.org',
        },
    },
    testnet: true,
    contracts: {
        multicall3: {
            address: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
            blockCreated: 358349,
        },
        universalSignatureVerifier: {
            address: '0xfB688330379976DA81eB64Fe4BF50d7401763B9C',
            blockCreated: 431682,
        },
    },
});
//# sourceMappingURL=abstractTestnet.js.map